export default {
  characters: "캐릭터",
  release: "출시",
  unrelease: "미출시"
};
